export default __webpack_public_path__ + "static/media/img8.59bff1cb.jpg";